'use client'
import { useEffect } from 'react';

// The root layout hardcodes <html lang="en">; translated pages correct it client-side.
export default function SetHtmlLang({ lang }: { lang: string }) {
  useEffect(() => {
    const previous = document.documentElement.lang;
    document.documentElement.lang = lang;
    return () => {
      document.documentElement.lang = previous;
    };
  }, [lang]);
  return null;
}
